import { render, staticRenderFns } from "./Legals.vue?vue&type=template&id=41cdbe90&"
import script from "./Legals.vue?vue&type=script&lang=ts&"
export * from "./Legals.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports